import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

function Pagination({ next, prev }) {
  return (
    <div className="pagination clearfix">
      <div className="alignleft">
        {next ? (
          <Link to={next} title="See older entries">
            « Older Entries
          </Link>
        ) : null}
      </div>
      <div className="alignright">
        {prev ? (
          <Link to={prev} title="See next entries">
            Next Entries »
          </Link>
        ) : null}
      </div>
    </div>
  )
}

Pagination.propTypes = {
  prev: PropTypes.string,
  next: PropTypes.string,
}

Pagination.defaultProps = {
  prev: null,
  next: null,
}

export default Pagination
